import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Card, AppCTA, AuthComponent, MenuItem, GridForm, Input, Button } from '../components';
import { accountConstants, routes, requestStatus } from '../constants';
import { formValidators, FormDelegate, AuthDelegate } from '../utils';
import { RouteActions, RegisterActions, GrowlActions } from '../actions';

const { statuses, loginStates } = accountConstants;

const validators = {
    sampleNumber: formValidators.required({
        message: 'Report Number is required'
    }),
    serialNumber: formValidators.required({
        message: 'Serial Number is required'
    }),
    postalCode: formValidators.required({
        message: 'Postal Code is required'
    })
}

class AccountVerifyPage extends AuthComponent {

    constructor(props) {
        super(props);

        this.formDelegate = new FormDelegate();
        this.formDelegate.onChange((output, valid, inputs) => this.changeHandler(output, valid, inputs));
        this.formDelegate.onSubmit((output, valid, inputs) => this.submitHandler(output, valid, inputs));

        this.state = {
            errors: []
        }
    }

    componentWillMount() {
        super.componentWillMount();
        this.props.dispatch(RouteActions.setAppState(routes.VERIFY));
    }

    userIsAuthorized(user) {
        return user.approvalStatus === statuses.UNSUBMITTED
            && user.loginState === loginStates.LOGGED_IN
    }

    componentWillRejectUser(user){
        if(!AuthDelegate.requireLogin(user)) {
            return;
        }

        switch (user.approvalStatus) {
            case statuses.APPROVED:
                browserHistory.push(routes.HOME);
                break;
            case statuses.SUBMITTED:
                this.props.dispatch(GrowlActions.notify('Your account has been created'));
                browserHistory.push(routes.SUBMITTED);
                break;
            default:
                browserHistory.push(routes.LOGIN);
                break;
        }
    }

    changeHandler() {
        this.setState({
            errors: this.formDelegate.getErrors()
        });
    }

    submitHandler(output, valid) {
        if (valid) {
            this.props.dispatch(RegisterActions.verifyUser(output, this.props.user))
        } else {
            this.setState({
                errors: this.formDelegate.getErrors()
            });
        }
    }

    authRender () {

        const errs = this.state.errors;
        let errMsg = '';

        if (errs.length > 0) {
            errMsg = errs[0].message;
        }

        if (this.props.verifyStatus.status === requestStatus.ERROR) {
            errMsg = 'There was an error submitting.  Please try again.';
        }

        return (
            <div className="container component-login-widget" id="verify-page">
                <div className="row center-cols">
                    <div className="col-sm-5">
                        <Card>
                            <div className="card-title-area">
                                <MenuItem className="unclickable" active={true}>Account Verification</MenuItem>
                            </div>
                            <div className="card-body">
                                <p className="verification-prompt">
                                    Please verify your account by submitting data from a previous report.
                                </p>
                                <form onSubmit={(e) => this.formDelegate.submit(e)}>
                                    <GridForm>
                                        <div className="form-group">
                                            <label className="form-control">Report Number</label>
                                            <Input className="form-control" name="sampleNumber" maxLength="10" delegate={this.formDelegate} validators={validators.sampleNumber} type="text" />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-control">Serial Number</label>
                                            <Input className="form-control" name="serialNumber" delegate={this.formDelegate} validators={validators.serialNumber} type="text" />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-control">Postal Code</label>
                                            <Input className="form-control" name="postalCode" delegate={this.formDelegate} validators={validators.postalCode} type="tel" />
                                        </div>
                                    </GridForm>
                                    <div className="form-footer">
                                        <div className="form-error">{errMsg}</div>
                                        <Button className="primary" type="submit">Submit</Button>
                                    </div>
                                </form>
                            </div>
                        </Card>
                        <AppCTA></AppCTA>
                    </div>
                </div>
            </div>
        )
    }
}

const select = state => {
    return {
        currentRoute: state.appState.currentRoute,
        user: state.activeUser,
        verifyStatus: state.verifyStatus
    }
}

export default connect(select)(AccountVerifyPage);



// WEBPACK FOOTER //
// ./web-app/containers/account-verify.jsx